export default () => ({
  countries: [],
  refer: [],
  users: [],
  branches: [],
  organizations: [],
  services: [],
  jobPositions: [],
  languages: [],
  educationSections: [],
  professionalFields: [],
  businessSectors: [],
  computerSkills: [],
  sectors: [],
  softSkillTrainings: [],
  programs: [],
  iscoCodes: [],
  academyOfficers: [],
  employabilityOfficers: [],
  courses: [],
  thematicAreas: [],
  courseTypes: [],
  courseSections: [],
  beneficiaries: [],
  communicationResponsibles: [],
  companies: [],
  emplServices: [],
  employmentFields: [],
  employabilities: [],
  livelihoods: [],
  taOfficers: [],
  locations: [],
  greekCities: [],
  professions: [],
  prevListHashes: [],
  listHashes: [],
  companiesSectors: [],
  shouldUpdate: {
    countries: false,
    referSources: false,
    branches: false,
    orzanizations: false,
    services: false,
    educationSections: false,
    professionalFields: false,
    businessSectors: false,
    computersSkills: false,
    sectors: false,
    softSkillTrainings: false,
    iscoCodes: false,
    thematicAreas: false,
    courseSections: false,
    courseTypes: false,
    emplServices: false,
    professions: false,
  },
});
